import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { toast } from "react-toastify";

import * as appReducer from "containers/App/reducer";
import * as runReducer from "containers/Run/reducer";
import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as createReducer from "containers/CreateWizard/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as oldProjectReducer from "containers/OldProject/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as transformReducer from "containers/Dataset/reducer";
import * as nextTransformReducer from "containers/Next/Transform/TransformReducer";

import DatasetRow from "components/View/Rows/DatasetRow";

import DatasetTileEDG from "components/Tiles/Dataset/Dataset";
import DatasetTile from "components/Tiles/DatasetTile";

import { isEnabled } from "utils/featureFlags";
import { getIsEDG } from "containers/Gallery/GalleryReducer";

class DatasetItem extends React.PureComponent {
  handleFile(event) {
    const { handleFileChange, validateFileExtension } = this.props;

    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    if (validateFileExtension(file)) {
      return handleFileChange(file, event.currentTarget);
    }
  }

  handleClick(data) {
    const {
      history,
      blueprintId,
      handleOpenBlueprint,
      updateStep,
      updateDatasetId,
      updateOpenUploadModal,
      resetSetup,
      updateProjectStep,
      updateTransform,
      updateLastRunId,
      reindexDataset,
      handleAddBlueprint,
      onClick,
      resetSearch,
      isConsumer,
      isChatStyle,
      switchTabToGPT
    } = this.props;

    const isAdvanced = isEnabled("aible-advanced");

    // Bad fix 2
    const isBlueprint =
      history && history.location && history.location.pathname && history.location.pathname.indexOf("blueprint") !== -1;

    const isNewBlueprint =
      history &&
      history.location &&
      history.location.pathname &&
      history.location.pathname.indexOf("blueprint/new") !== -1;

    const isBusiness = isEnabled("aible-business-simple");

    if (isConsumer && onClick) {
      return onClick(data.id);
    }

    let noFileError =
      data && data.errors && data.errors.find((record) => record.message === "Didn't detect properly as a CSV!");

    const datasetNeedsReindex =
      (data && data.updated_date && uploadReducer.getDatasetNeedsReindex(data)) || noFileError;

    if (
      !datasetNeedsReindex &&
      data &&
      data.status &&
      data.status.indexOf("missing_target_variable") !== -1 &&
      !getIsEDG()
    ) {
      return updateOpenUploadModal(true, data.id);
    } else {
      if (datasetNeedsReindex) {
        if (!data.stack_id) {
          return reindexDataset();
        } else {
          toast("There is currently an operation in progress on this dataset. Please try again in 5 minutes.", {
            type: toast.TYPE.ERROR,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 7500
          });
        }
      } else {
        if (onClick) {
          return onClick(data.id);
        }

        if (isEnabled("aible-next") || true) {
          if (blueprintId === "newBlueprint" || blueprintId === "new") {
            return history.push("/next/" + data.id + "/new/new");
          }

          if (isChatStyle) {
            switchTabToGPT();
          }
          let url = "/next/" + data.id + "/new";

          if (blueprintId !== undefined) {
            url += "?blueprintId=" + blueprintId;
          }
          history.push(url);

          return Promise.resolve();
        }

        if (onClick) {
          return onClick(data.id);
        } else {
          if (!isBlueprint || isNewBlueprint) {
            updateTransform("new", undefined);
          }

          if (isEnabled("edg") || isEnabled("aible-consumer")) {
            return history.push("gallery/" + data.id + (data.jId ? "/" + data.jId : ""));
          }

          handleOpenBlueprint("academic", data.id);

          return Promise.resolve();
        }
      }
    }
  }

  renderTile(data) {
    const { index, updateHoverDataset, style, onClick, noClick, handleDelete, canDelete, ...retProps } = this.props;

    const retOnClick = noClick ? undefined : () => this.handleClick(data);
    const retHandleDelete = noClick || !canDelete ? undefined : handleDelete;

    return (
      <div style={style} key={index}>
        <DatasetTile
          {...retProps}
          dataset={data}
          onHover={(id) => updateHoverDataset(id)}
          onClick={retOnClick}
          handleDelete={handleDelete}
          index={index}
        />
        {/* {!isEnabled("edg") ? (
          <DatasetTileEDG
            {...retProps}
            dataset={data}
            onHover={(id) => updateHoverDataset(id)}
            onClick={retOnClick}
            handleDelete={retHandleDelete}
            index={index}
          />
        ) : (
          <DatasetTile
            {...retProps}
            dataset={data}
            onHover={(id) => updateHoverDataset(id)}
            onClick={retOnClick}
            handleDelete={retHandleDelete}
            index={index}
          />
        )} */}
      </div>
    );
  }

  renderRow(data) {
    const { index, isHighlight, updateHoverDataset } = this.props;

    return (
      <DatasetRow
        dataset={data}
        onHover={(id) => updateHoverDataset(id)}
        onClick={() => this.handleClick(data)}
        isHighlight={isHighlight}
        key={index}
      />
    );
  }

  render() {
    const { isTile, fetchNext, isJobsLoading, data } = this.props;

    return isTile ? this.renderTile(data) : this.renderRow(data);
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  validateFileExtension: (file, extension) => uploadReducer.validateFileExtension(file, extension),
  updateDatasetId: (datasetId) =>
    dispatch(setupReducer.updateDatasetIdWithScroll("new", datasetId, ownProps.blueprintId)),
  resetSetup: (id) => dispatch(setupReducer.resetSetup(id)),

  updateStep: (step) => dispatch(createReducer.updateStep(step)),

  handleFileChange: (file) => dispatch(uploadReducer.handleFileChange(file)),
  updateOpenUploadModal: (isOpen, datasetId) => dispatch(uploadReducer.handleOpenUpload(isOpen, datasetId)),

  updateHoverDataset: (id) => dispatch(globalReducer.updateHoverDataset(id)),

  fetchNext: () => dispatch(homeReducer.fetchNextDatasets()),
  handleDelete: () => dispatch(homeReducer.deleteDataset(ownProps.id)),

  updateProjectStep: (step) => dispatch(oldProjectReducer.updateStep(step)),
  updateLastRunId: (runId) => dispatch(oldProjectReducer.updateLastRunId(runId)),
  updateTransform: (id, transform) => dispatch(transformReducer.updateTransform(id, transform)),

  reindexDataset: () => dispatch(uploadReducer.reindexDataset(ownProps.id)),

  handleOpenBlueprint: (blueprintId, datasetId) =>
    dispatch(blueprintReducer.handleOpenBlueprint(blueprintId, datasetId)),

  resetSearch: () => dispatch(viewReducer.updateSearch(undefined)),

  openSchemaMonitor: () => dispatch(homeReducer.selectAndOpenMonitorSchema(ownProps.id)),

  handleAddBlueprint: (blueprintId) => dispatch(nextTransformReducer.handleAddBlueprint("new", blueprintId)),

  switchTabToGPT: () => dispatch(globalReducer.updateShouldSwitchToGPT(true))
});

const mapStateToProps = (state, ownProps) => {
  const dataset = homeReducer.getDataset(state, ownProps.id);

  const hoverItem = globalReducer.getHoverItem(state);

  const highlightId =
    hoverItem && hoverItem.hoverType === "RUN"
      ? runReducer.getTransformedJob(state, hoverItem.id).datasetId
      : hoverItem && hoverItem.hoverType === "BLUEPRINT"
        ? blueprintReducer.getOriginalDatasetId(state, hoverItem.id)
        : undefined;

  const aiReadyMetrics = setupReducer.getAiReadyMetrics(state, undefined, ownProps.id) || {};

  const linkedBlueprints = homeReducer.getLinkedBlueprints(state, ownProps.id);

  return {
    isTile: ownProps.isTile ? ownProps.isTile : viewReducer.getIsTile(state),
    type: viewReducer.getType(state),

    data: ownProps.data ? ownProps.data : homeReducer.getDataset(state, ownProps.id),
    outcomeType: homeReducer.getOutcomeType(state, ownProps.id),

    isHighlight: dataset !== undefined && highlightId !== undefined && highlightId === dataset.id,

    tableauData: loginReducer.getTableauDataOptions(state),
    isTabUploading: loginReducer.getIsTabUploading(state),
    isDataUploading: globalReducer.getIsDataUploading(state),
    isDatasetsLoading: globalReducer.getIsDatasetsLoading(state),

    dataSourceDetails: homeReducer.getDatasetSourceDetails(state, ownProps.id),

    isAiReady: aiReadyMetrics.isAiReady || aiReadyMetrics.aiReadinessStatus !== "NO_SIGNAL",
    isMultiCategoryOutcome: aiReadyMetrics.isMultiCategoryOutcome,

    isDataMode: appReducer.getIsDataMode(state),
    canDelete: homeReducer.getUserDeletePermission(state, ownProps.id),

    linkedSchemaChanges: homeReducer.getLinkedSchemaChanges(state, ownProps.id),
    isLinkedSchemaChanged: homeReducer.getIsLinkedSchemaChanged(state, ownProps.id),

    aiReadyMetrics: aiReadyMetrics,

    analyzedOutcomes: homeReducer.getAnalyzedOutcomes(state, ownProps.id),
    aiReadyOutcomes: homeReducer.getAiReadyOutcomes(state, ownProps.id),

    isForecastReady: homeReducer.getIsForecastReady(state, ownProps.id),

    userInfoQuery: loginReducer.createUserInfoQuery(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DatasetItem);
